/**
 * ── ONDE O VÍDEO COMEÇA: o `?t=` do link fundo vence a retomada (F12 · D5) ──
 *
 * O assessor da área cita «aula X, 12:40» com um link `/aula/<id>?t=760` — o
 * mesmo `destino` que o coletor grava (`docs/agentes-arquitetura.md` §12.4,
 * D4). Até aqui ninguém lia o `t`: `grep "get('t')" apps/aluno/src` = 0, e o
 * player só conhecia `posicaoParaRetomar`. O link abria a aula certa e
 * começava do zero — a promessa da tela («cada resposta vem com a aula e o
 * minuto de onde saiu») era decorativa.
 *
 * A regra, pura e conferível sem navegador:
 *
 * 1. `t` explícito e válido VENCE a retomada — quem clicou num minuto quer
 *    aquele minuto, não onde parou ontem. `t=0` também vence: é «do começo»,
 *    dito com todas as letras;
 * 2. `t` fora de `[0, duração]` cai para a retomada — um minuto além do fim
 *    (aula reeditada, trecho antigo) ou negativo não é posição; é ruído, e o
 *    comportamento de antes é o certo;
 * 3. sem `t`, a retomada decide, como sempre (`posicaoParaRetomar`, no core,
 *    que já recusou os dois extremos que não valem a viagem).
 *
 * `duracao` nula (o servidor ainda não mediu) não recusa o `t`: a única régua
 * que sobra é `t >= 0`. E o retorno é em segundos inteiros, que é o que
 * `currentTime` recebe e o que `?t=` carrega.
 *
 * Não alcança a aula escrita: o link do trecho `corpo:<n>` abre a aula sem
 * `?t=`, e é isso que ele promete (§11.7.1).
 */
export function posicaoInicial(p: {
  /** O `t` da query, cru — string do `URLSearchParams`, ou já número. */
  t: string | number | null | undefined;
  /** `progresso.retomarEm`, já decidido pelo servidor. */
  retomar: number | null;
  /** A duração conhecida, em segundos; nula quando ninguém mediu. */
  duracao: number | null;
}): number | null {
  const t =
    typeof p.t === 'number'
      ? p.t
      : typeof p.t === 'string' && p.t.trim() !== ''
        ? Number(p.t)
        : NaN;
  const dentro = Number.isFinite(t) && t >= 0 && (p.duracao === null || t <= p.duracao);
  if (dentro) return Math.floor(t);
  return p.retomar;
}
